import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-green-brand" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  const r = user.role;
  const path = (() => {
    if (r === "super_admin") return "/admin";
    if (r === "owner") return "/owner";
    return "/cliente";
  })();

  if (role && role !== r) return <Navigate to={path} replace />;
  return children;
}
